import { selectLayout } from "redux/preferencesSlice";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import TopNavLayout from "./TopNavLayout/TopNavLayout";
import DrawerLayout from "./DrawerLayout/DrawerLayout";
import { Box, Typography } from "@mui/material";

interface CustomProps {
  children: any;
  hideNavs?: boolean;
}

const Layout = (props: CustomProps) => {
  const dispatch = useAppDispatch();
  const layout = useAppSelector(selectLayout);

  if (props.hideNavs) {
    return <>{props.children}</>;
  }
  switch (layout) {
    case "horizontal":
      return <TopNavLayout>{props.children}</TopNavLayout>;
    case "vertical":
      return <DrawerLayout>{props.children}</DrawerLayout>;
    default:
      return <DrawerLayout>{props.children}</DrawerLayout>;
  }
};

export default Layout;
